module.exports = __webpack_public_path__ + "static/media/146.20cc98ef.png";